<div
  #sidebar
  class="sidebar"
  [style.transform]="
    isMobileScreenSize()
      ? (sidebarOpen$ | async)
        ? 'translateY(' + topLimit + '%)'
        : 'translateY(' + calcHeaderHeight() + '%)'
      : ''
  "
>
  @if (isMobileScreenSize()) {
    <div class="header">
      <div
        class="handle-container"
        (mousedown)="onDragStart($event)"
        (touchstart)="onDragStart($event)"
      >
        <div class="handle"></div>
      </div>
      <ng-content select="[sidebar-header]" />
    </div>
  } @else {
    <div class="header">
      <fa-icon
        (click)="isCollapsed = !isCollapsed"
        [icon]="isCollapsed ? faCircleChevronRight : faCircleChevronLeft"
      />
    </div>
  }
  <div
    class="sidebar-content"
    [style.padding-bottom]="isMobileScreenSize() ? headerHeight() + 'px' : ''"
  >
    <ng-content select="[sidebar]" />
  </div>
</div>
<lyceo-content
  [maxWidth]="maxWidth()"
  [background]="background()"
  [alternate]="alternate()"
  class="content"
>
  @if (isMobileScreenSize()) {
    <div
      (click)="dismissSidebar()"
      class="backdrop"
      [class.show]="sidebarOpen$ | async"
    ></div>
  }
  <ng-content select="[content]" />
</lyceo-content>
